import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { GeneralServicesImplService } from 'src/services/general-services-impl.service';
import * as servers from '../../../../services/api/servers';
import {urls} from '../../../../services/api/urls';
import { ProjectConstants } from 'src/app/project-constants';

@Injectable({
    providedIn: 'root'
  })
  export class ConsuntivoForecastService extends GeneralServicesImplService {
    constructor(http: HttpClient) {
      super(http);
    }
    baseUrl: string = servers.apiUrl + urls.forecastController;
  
    getPage(filters: any, payload?: any): Observable<any> {
      const url = this.baseUrl + this.LINKS.PAGE;
      const body =  payload ? JSON.stringify(payload) : null;
      const header = ProjectConstants.returnGeneralHeader();
      return this.http.post( url, body, {headers: header, responseType: 'json', params: filters})
        .pipe(
          // map (data => data) da inserire gestione errori
        );
    }
  
    getNameGenerateXlsx(offset, payload: any, comparing: boolean) {
      let url = this.baseUrl;
      if (comparing) {
        url = url + this.LINKS.GENERATE_COMPARISON_XLSX;
      } else {
        url = url + this.LINKS.GENERATE_XLSX;
      }
      const body =  payload ? JSON.stringify(payload) : null;
      const header = ProjectConstants.returnGeneralHeader();
  
      return this.http.post( url, body, {headers: header, responseType: 'blob', params: offset})
        .pipe(
          // map (data => data) da inserire gestione errori
        );
  
    }
  
   
  }
  